import { Modal, PrimaryButton } from '@cb/apricot-react';
import { FC } from 'react';
import { ISummary } from 'src/types';

interface ViewVettingNotesModalProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  summary: ISummary | null;
}

const ViewVettingNotesModal: FC<ViewVettingNotesModalProps> = ({ isOpen, onClose, summary }) => {
  const notes = summary?.adminNotes?.slice().sort((a, b) => b.time - a.time) || [];
  return (
    // @ts-ignore
    <Modal
      title="Review Internal Vetting Notes"
      actions={[
        <PrimaryButton key="close" onClick={onClose}>
          Close
        </PrimaryButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {notes.length > 0 &&
        (
          notes.map((note) => {
            const date = new Date(note.time).toLocaleString();
            return <div style={{ marginBottom: '10px' }}>
              <div style={{ fontWeight: 500, backgroundColor: '#f6f6f6', borderRadius: '5px', padding: '5px 5px', whiteSpace: 'pre-line' }}>{note.message}</div>
              <div style={{ fontSize: 11, color: '#7b7b7b' }}>
                <span style={{ fontStyle: 'italic' }}>{note.user || ''}</span>
                &nbsp;@&nbsp;
                {date}
              </div>
              <div ></div>
            </div>;
          })
        )
      }
    </Modal>
  );
};

export default ViewVettingNotesModal;
